import { render } from "./TextMediaSection.vue?vue&type=template&id=15ae00c4"
import script from "./TextMediaSection.vue?vue&type=script&lang=js"
export * from "./TextMediaSection.vue?vue&type=script&lang=js"

import "./TextMediaSection.vue?vue&type=style&index=0&id=15ae00c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__